import {RouteProps} from 'config/navigation';
import {MdCreditCard} from 'react-icons/md';
import Invoices from './invoices';

const invoicesPages: RouteProps = {
  name: 'Notas Fiscais',
  path: 'invoices',
  permission: 'invoices.findAll',
  icon: <MdCreditCard />,
  subRoutes: [
    {
      path: '',
      element: <div />,
      permissions: ['invoices.findAll'],
    },
  ],
};

export default invoicesPages;
